import { useState } from 'react'

import { EMPTY_LIST } from '../../../constants/common'
import { EmailProfileMessagesListExpandContext } from '../Email.contexts'

function EmailProfileMessagesListExpandContextProvider({ children, messages }) {
  const [expandedIds, setExpandedIds] = useState(
    () => new Set(messages?.length > 0 ? [messages[0].uuid] : EMPTY_LIST)
  )

  function expandMessage(messageId) {
    setExpandedIds(prev => {
      if (prev.has(messageId)) {
        return prev
      }

      const next = new Set(prev)

      next.add(messageId)

      return next
    })
  }

  function collapseMessage(messageId) {
    setExpandedIds(prev => {
      if (!prev.has(messageId)) {
        return prev
      }

      const next = new Set(prev)

      next.delete(messageId)

      return next
    })
  }

  function toggleExpandMessage(messageId) {
    setExpandedIds(prev => {
      const newSet = new Set(prev)

      if (newSet.has(messageId)) {
        newSet.delete(messageId)
      } else {
        newSet.add(messageId)
      }

      return newSet
    })
  }

  function expandAll() {
    setExpandedIds(new Set(messages.map(m => m.uuid)))
  }

  function collapseAll() {
    setExpandedIds(new Set())
  }

  function toggleAll() {
    setExpandedIds(prev => {
      const allExpanded = messages.length > 0 && prev.size === messages.length

      return allExpanded ? new Set() : new Set(messages.map(m => m.uuid))
    })
  }

  const total = messages?.length
  const expandedCount = expandedIds.size

  const isAllExpanded = total > 0 && expandedCount === total
  const isAllCollapsed = expandedCount === 0

  const value = {
    collapseAll,
    collapseMessage,
    expandAll,
    expandedIds,
    expandMessage,
    isAllCollapsed,
    isAllExpanded,
    isExpanded: id => expandedIds.has(id),
    toggleAll,
    toggleExpandMessage,
  }

  return (
    <EmailProfileMessagesListExpandContext value={value}>
      {children}
    </EmailProfileMessagesListExpandContext>
  )
}

export default EmailProfileMessagesListExpandContextProvider
